var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { ContextMenuAFY, icons, sizesIcon, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { SpanStatus } from "../style/productCreation.style";
import { ACTION_FLAG_ACTIVE_LABEL } from "./productCreation.constants";
var ACTIONS_COLUMN_WIDTH = 80;
var STATUS_ACTIVE_COLOR = "#46c51a";
var STATUS_INACTIVE_COLOR = "#ef2f24";
var CONTEXT_MENU_PROPS = {
    colorButton: "#fff",
    iconButton: icons.MoreVert,
    iconColor: "#3A56A1",
    sizeIcon: sizesIcon.standard,
};
var MENU_ICON_COLOR = "#006ac6";
var buildActionsColumn = function (canEdit, menuItem, onClick) { return ({
    field: "actions",
    headerName: "",
    width: ACTIONS_COLUMN_WIDTH,
    renderCell: function (params) { return (_jsx("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: canEdit && (_jsx(ContextMenuAFY, __assign({}, CONTEXT_MENU_PROPS, { menuItem: menuItem, onClickContextMenu: function () { return onClick(params === null || params === void 0 ? void 0 : params.row); } }))) }))); },
}); };
var DELETE_MENU_ITEM = [
    {
        disabled: false,
        icon: {
            color: MENU_ICON_COLOR,
            icon: icons.DeleteForever,
            size: sizesIcon.standard,
        },
        id: "1",
        name: "Eliminar",
    },
];
var VIEW_PLAN_MENU_ITEM = [
    {
        disabled: false,
        icon: {
            color: MENU_ICON_COLOR,
            icon: icons.Visibility,
            size: sizesIcon.standard,
        },
        id: "1",
        name: "Ver plan",
    },
];
var buildCatalogColumns = function (canEdit, onClickDelete) { return [
    buildActionsColumn(canEdit, DELETE_MENU_ITEM, onClickDelete),
    {
        editable: false,
        field: "code",
        flex: 1,
        headerName: "Código",
        width: 150,
    },
    {
        editable: false,
        field: "description",
        flex: 1,
        headerName: "Descripción",
        width: 160,
    },
]; };
export var buildRecurrenceColumns = function (canEdit, onClickDelete) { return buildCatalogColumns(canEdit, onClickDelete); };
export var buildPaymentModeColumns = function (canEdit, onClickDelete) { return buildCatalogColumns(canEdit, onClickDelete); };
export var buildPlansColumns = function (canEdit, onClickViewPlan) { return [
    buildActionsColumn(canEdit, VIEW_PLAN_MENU_ITEM, onClickViewPlan),
    {
        field: "code",
        headerName: "Código",
        width: 180,
    },
    {
        field: "name",
        headerName: "Nombre",
        width: 180,
        flex: 1,
    },
    {
        field: "coverType",
        headerName: "Tipo de cobertura",
        width: 230,
        flex: 1,
    },
]; };
var isActiveFlag = function (row) {
    return row.value === ACTION_FLAG_ACTIVE_LABEL;
};
export var buildFlagsColumns = function (canEdit) { return [
    {
        field: "actions",
        headerName: "",
        width: ACTIONS_COLUMN_WIDTH,
        renderCell: function (params) { return (_jsx("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: canEdit && (_jsx(ContextMenuAFY, __assign({}, CONTEXT_MENU_PROPS, { menuItem: [
                    isActiveFlag(params.row)
                        ? {
                            disabled: false,
                            icon: {
                                color: STATUS_INACTIVE_COLOR,
                                icon: icons.Unpublished,
                                size: sizesIcon.standard,
                            },
                            id: "1",
                            name: "Desactivar",
                        }
                        : {
                            disabled: false,
                            icon: {
                                color: STATUS_ACTIVE_COLOR,
                                icon: icons.CheckCircle,
                                size: sizesIcon.standard,
                            },
                            id: "2",
                            name: "Activar",
                        },
                ] }))) }))); },
    },
    {
        editable: false,
        field: "value",
        headerName: "Estado",
        width: 180,
        renderCell: function (params) { return (_jsxs("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: [_jsx(SpanStatus, { style: {
                        backgroundColor: isActiveFlag(params.row)
                            ? STATUS_ACTIVE_COLOR
                            : STATUS_INACTIVE_COLOR,
                    } }), params.value] }))); },
    },
    {
        editable: false,
        field: "name",
        headerName: "Nombre",
        width: 180,
        flex: 1,
    },
]; };
